import React from 'react';
import { useParams } from "react-router-dom";
import { NotificationService } from "../../../common/notification";
import CircularProgress from "@mui/joy/CircularProgress";
import Box from "@mui/joy/Box";
import { LineChart } from "@mui/x-charts/LineChart";
import { kopecksToRublesNumber } from "../../../common/money";
import { formatDateTime } from "../../../common/dateTime";
import { userBalanceHistoryApi } from "../usersApi";
import { FilterBar } from "../../dashboard/components";
import { toInputValue, subtractMonths } from "../../dashboard/utils/date";

export function UserBalanceHistory() {
    const { id } = useParams();
    const [balanceHistory, setBalanceHistory] = React.useState<any>([]);
    const [loading, setLoading] = React.useState(false);
    const [fromDate, setFromDate] = React.useState<string>(() => {
        const now = new Date();
        const from = subtractMonths(now, 1);
        return toInputValue(from);
    });
    const [toDate, setToDate] = React.useState<string>(() => toInputValue(new Date()));

    React.useEffect(() => {
        if (id && BigInt(id) > 0) {
            const from = new Date(fromDate);
            const to = new Date(toDate);
            load(BigInt(id), from, to).catch(console.error);
        }
    }, [id, fromDate, toDate]);

    const load = async (id: bigint, from?: Date, to?: Date) => {
        try {
            setLoading(true);
            let result = await userBalanceHistoryApi(id, from, to);
            if (result.result) {
                setBalanceHistory((result.value ?? []).map((item: any) => ({
                    ...item,
                    value: typeof item.value === 'number' ? kopecksToRublesNumber(item.value) : item.value
                })));
            } else {
                NotificationService.alertError("Пожалуйста попробуйте позже или обратитесь в службу поддержки")
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <Box>
            <FilterBar
                loading={loading}
                onApplyRange={(from, to) => {
                    setFromDate(from);
                    setToDate(to);
                }}
            />
            {loading ? (
                <CircularProgress />
            ) : (
                <LineChart
                    dataset={balanceHistory}
                    xAxis={[
                        {
                            dataKey: 'date',
                            scaleType: 'band',
                            valueFormatter: (value: unknown) => {
                                return formatDateTime(value as any);
                            }
                        },
                    ]}
                    series={[
                        {
                            dataKey: 'value',
                            label: 'Баланс',
                        }
                    ]}
                    height={300}
                />
            )}
        </Box>
    );
}
